<template>
  <div>
    <WithCustomerOrder
      :customer-id="entity.user_id"
      :order-id="entity.id"
      v-slot="{ order, loading }"
    >
      <transition name="fade-fast" mode="out-in">
        <div v-if="loading" class="text-center" key="loading-invoice">
          <h3 class="mt-2">Loading Order Items</h3>
          <v-progress-circular indeterminate class="mt-2" size="20" width="2" />
        </div>
        <div v-else>
          <v-row no-gutters>
            <v-col cols="6">
              <h2>Ticket #{{ entity.ticket_number }}</h2>
              <h2>{{ order.customer.full_name }}</h2>
            </v-col>
            <v-col cols="6" class="text-right">
              <div>{{ order.time_ordered }}</div>
              <div
                >{{ order.fulfillment_type }} -
                {{ order.availability.name }}</div
              >
              <div>{{ order.fulfillment_slot }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div>Phone : {{ order.customer.phone || '-' }}</div>
              <div>Address : {{ order.delivery_address || '-' }}</div>
              <div v-if="order.special_instructions"
                >Special Instructions :
                {{ order.special_instructions || '-' }}</div
              >
            </v-col>
          </v-row>

          <AdminFieldLineItems :order="order" />

          <AdminFieldWrapper>
            <h3 class="mt-2 text-right"
              ><span class="mr-2">Total Cost: </span
              >{{ entity.grand_total_formatted }}</h3
            >
          </AdminFieldWrapper>
        </div>
      </transition>
    </WithCustomerOrder>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import OrderModel from '@/models/OrderModel'
import WithCustomerOrder from '@/components/DataProviders/WithCustomerOrder'

import _get from 'lodash/get'

import AdminFieldWrapper from '@/components/AdminFieldWrapper'
import AdminFieldLineItems from '@/components/AdminFieldLineItems'
export default {
  name: 'AdminPrintOrder',
  components: {
    WithCustomerOrder,
    AdminFieldWrapper,
    AdminFieldLineItems,
  },
  props: {
    entity: {
      type: OrderModel,
      require: true,
      default: () => new OrderModel(),
    },
  },
  data() {
    return {
      OrderModel,
    }
  },
  methods: {
    _get,
  },
  mounted() {},
  computed: {
    ...mapGetters('shop', ['getFulfillmentOptions', 'getFulfillmentSlotsList']),
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults }
    },
  },
  watch: {
    isFormValid(validity) {
      this.$emit('form:valid', validity)
    },
  },
}
</script>
